import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const mainArticle = articles[0];
  const subArticles = articles.slice(1, 4);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新资讯
            </h2>
            <p className="text-sm text-foreground-600">
              日韩影视圈最新动态与深度解析
            </p>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          <Link
            to={`/article/${mainArticle.id}`}
            className="lg:w-1/2 group cursor-pointer"
          >
            <div className="relative rounded-xl overflow-hidden aspect-video lg:aspect-[16/9] mb-4">
              <img
                src={mainArticle.image}
                alt={mainArticle.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute top-3 left-3 bg-accent-500 text-background-50 dark:text-foreground-950 text-xs font-medium px-3 py-1 rounded-full">
                {mainArticle.category}
              </div>
            </div>
            <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 mb-2">
              {mainArticle.title}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
              {mainArticle.excerpt}
            </p>
            <div className="flex items-center gap-3 text-xs text-foreground-500">
              <span>{mainArticle.author}</span>
              <span>·</span>
              <span>{mainArticle.date}</span>
            </div>
          </Link>

          <div className="lg:w-1/2 flex flex-col gap-4">
            {subArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex flex-col sm:flex-row gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors duration-200 cursor-pointer"
              >
                <div className="sm:w-[180px] shrink-0">
                  <div className="relative rounded-lg overflow-hidden aspect-video sm:aspect-[4/3]">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute top-2 left-2 bg-accent-500/80 text-background-50 dark:text-foreground-950 text-xs font-medium px-2 py-0.5 rounded-full">
                      {article.category}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col justify-center flex-1 min-w-0">
                  <h3 className="text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-600 line-clamp-2 mb-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span>{article.date}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}